import React, {Component} from "react";
import HallBasicInfoCard from "./HallBasicInfoCard/HallBasicInfoCard.component";
import ServerCard from "./ServerCard/ServerCard.component";

import "./HallPage.component.scss";
import {withRouter, RouteComponentProps} from "react-router-dom";
import {ActionCreator} from "../../../../actions/actions";
import {connect} from "react-redux";
import {HallsActionCreators} from "../../actions/actionCreators";
import {ReturnTo} from "../../../../utils/ReturnTo/ReturnTo.component";
import {hallsStoreSelectors} from "../../store/store";
import {HallBaseConfig} from "../../reducers/hallsList.reducer";
import {HallServer, License} from "../../reducers/inspectingHall.reducer";
import ServerCreate from "./ServerCreate/ServerCreate.component";
import ServerClone from "./ServerClone/ServerClone.component";
import Drawer from "../../../../utils/Drawer/Drawer.component";
import CreateHall from "../HallsList/CreateHall/CreateHall.component";
import {CreationModes} from "../../reducers/creationMode.reducer";
import {Dialog} from "../../../../utils/Dialog/Dialog.component";
import {
    checkAuthorization,
    checkPermission
} from "../../../../utils/Authorization/authorization";
import {AuthorizationServiceTypes} from "../../../../utils/Authorization/authorizationTypes";
import ServerEdit from "./ServerEdit/ServerEdit.component";
import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";
import Form from "../../../../utils/forms/components/Form";
import {FormGridField} from "../../../../utils/forms/components/FormGrid";
import * as Yup from "yup";
import RemoteUpdateOptions, {
    getRemoteUpdateIncludes,
    prepareRemoteRTPProfiles,
    supportsRemoteRTPProfileUpdate,
    supportsRemoteGameLogoUpdate
} from "../RemoteUpdateOptions/RemoteUpdateOptions.component";
import {GameRTPProfilePayload} from "../../../configurations/components/Utils/rtp-profiles";

interface uploadRemotelyData {
    open: boolean;
    serverId?: number;
    serverVersion?: string;
    gameRTPProfiles?: GameRTPProfilePayload[];
}

const sessionTimeSchema = Yup.string()
    .required("Field is required.")
    .matches(
        new RegExp(/^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})$/),
        `Format must match YYYY-MM-DD MM:SS (24H).`
    );

const sessionTimeFormFields: FormGridField[] = [
    {
        name: "update_time",
        fieldType: "date",
        fieldOptions: {
            id: "update_time",
            inputType: "date",
            label: "Update Time",
            placeholder: "YYYY-MM-DD HH:MM",
            showtime: true,
            minutesinterval: 5
        },
        validation: sessionTimeSchema,
        columnClass: "fixed-size",
        formSpacing: false
    }
];

export interface HallPageForms {
    showCreateServer: boolean;
    showDelHall: boolean;
    editingServer: any;
    cloningServer: any;
    searchText: string;
    serverVersionFilterValue: string;
    statusFilterValue: string;
    confirmUploadRemotely: uploadRemotelyData;
    uploadRemotelyDialog: boolean;
    selectedUpdateTime: string;
    selectedUpdateTimeValid: boolean;
    includeServerConfig: boolean;
    includeGameLogos: boolean;
    gameRTPProfiles: GameRTPProfilePayload[];
}

export interface HallPageProps extends RouteComponentProps {
    getHall: ActionCreator;
    inspectingHall: HallBaseConfig;
    inspectingHallServers: HallServer[];
    getServers: ActionCreator;
    getCoreVersions: ActionCreator;
    coreVersions: any;
    secure_connection: boolean;
    inspectingHallLoading: boolean;
    createServer: ActionCreator;
    updateCreationMode: ActionCreator;
    creationMode: any;
    clearCreateHall: ActionCreator;
    deleteHall: ActionCreator;
    activateServer: ActionCreator;
    updateCreatingHall: ActionCreator;
    serversInfo: any;
    serversInfoLoading: boolean;
    updateServer: ActionCreator;
    cloneServer: ActionCreator;
    submittingServerLoading: boolean;
    inspectingHallServersLoading: boolean;
    toggleServerDebugMode: ActionCreator;
    toggleServerPerpetualLicense: ActionCreator;
    getProductionServer: ActionCreator;
    productionServer: any;
    uploadConfigurationRemotely: ActionCreator;
}

class HallPage extends Component<HallPageProps, HallPageForms> {
    private drawerRef: React.RefObject<Drawer>;
    private drawerRefEdit: React.RefObject<Drawer>;
    serverVersionFilter: React.RefObject<Components.SelectMenu>;

    constructor(props) {
        super(props);
        this.state = {
            showCreateServer: false,
            showDelHall: false,
            editingServer: null,
            cloningServer: null,
            searchText: "",
            serverVersionFilterValue: "",
            statusFilterValue: "true",
            confirmUploadRemotely: {
                open: false,
                serverId: null,
                serverVersion: null
            },
            uploadRemotelyDialog: false,
            selectedUpdateTime: null,
            selectedUpdateTimeValid: false,
            includeServerConfig: true,
            includeGameLogos: true,
            gameRTPProfiles: []
        };
        this.drawerRef = React.createRef();
        this.serverVersionFilter = React.createRef();

        this.getServers()
        this.props.getProductionServer()
    }


    componentDidMount() {
        this.props.getHall({
            hallId: this.props.match.params["hallId"]
        });
    }

    getServers = () => {
        if (checkPermission("list_servers")) {
            this.props.getServers({
                hallId: this.props.match.params["hallId"],
                search: this.state.searchText,
                status: this.state.statusFilterValue,
                version: this.state.serverVersionFilterValue
            });
            this.props.getCoreVersions();
        }
    }

    onDialogConfirm = creatingServer => {
        /*
        let subsidiary = this.props.inspectingHall ? this.props.inspectingHall.subsidiary.id : null
        let perpetual_license = 0

        if((
            creatingServer.serverVersion=="1.9.51"
            ||
            (
                (
                    parseInt(creatingServer.serverVersion.substring(0,creatingServer.serverVersion.indexOf('.')))>=2
                    &&
                    parseInt(creatingServer.serverVersion.substring(creatingServer.serverVersion.indexOf('.')+1, creatingServer.serverVersion.lastIndexOf('.')))>=1
                )
            )
        )
        && subsidiary==9) perpetual_license = 1

         */

        this.props.createServer({
            hallId: this.props.inspectingHall.id,
            type: creatingServer.type,
            system_server_version: creatingServer.serverVersion,
            name: creatingServer.name,
            secure_connection: creatingServer.secure_connection,
            is_egames: creatingServer.is_egames,
            //perpetual_license: perpetual_license,
            filter: {
                search: this.state.searchText,
                status: this.state.statusFilterValue,
                version: this.state.serverVersionFilterValue
            }
        });
    };

    onDialogClose = () => {
        this.props.updateCreationMode(null);
    };

    closeCreateHall = () => {
        this.props.clearCreateHall();
    };

    addServerClick = () => {
        this.drawerRef.current != null &&
        this.drawerRef.current.props.onClose();

        this.props.updateCreationMode(CreationModes.ADD_SERVER);
    };

    //UPD hall
    onOpenEditHall = () => {
        if (this.props.inspectingHall) {
            this.props.updateCreatingHall(
                {
                    name: this.props.inspectingHall.name,
                    address_line_1: this.props.inspectingHall.address_line_1,
                    address_line_2: this.props.inspectingHall.address_line_2,
                    allow_license_renew:
                    this.props.inspectingHall.allow_license_renew,
                    renewal_trigger_days: this.props.inspectingHall.renewal_trigger_days,
                    allow_license_automatic_renew: this.props.inspectingHall.allow_license_automatic_renew
                },
                true
            );

            this.drawerRef.current != null &&
            this.drawerRef.current.props.onClose();
            this.props.updateCreationMode(CreationModes.EDIT_HALL);
        }
    };
    //UPD hall

    //DEL hall
    delHallClick = status => {
        this.setState({
            showDelHall: status
        });
    };

    closeDelHall = () => {
        this.delHallClick(false);
    };

    onDeleteHall = () => {
        this.props.deleteHall(this.props.inspectingHall.id);
    };
    //DEL hall

    onEdit = server => {
        this.setState({
            editingServer: {
                name: server.name,
                id: server.id
            }
        });
        this.props.updateCreationMode(CreationModes.EDIT_SERVER);
    };

    onEditConfirm = server => {
        this.props.updateServer({
            id: server.id,
            name: server.name,
            hallId: this.props.inspectingHall.id,
            filter: {
                search: this.state.searchText,
                status: this.state.statusFilterValue,
                version: this.state.serverVersionFilterValue
            }
        });
    };

    closeEditServer = () => {
        this.setState({
            editingServer: null
        });
        this.props.updateCreationMode(null);
    };

    onClone = server => {
        this.setState({
            cloningServer: {
                id: server.id,
                name: server.name,
                system_server_version: server.system_server_version,
                secure_connection: server.secure_connection,
                is_egames: server.is_egames
            }
        });
        this.props.updateCreationMode(CreationModes.CLONE_SERVER);
    };

    onCloneConfirm = server => {
        this.props.cloneServer({
            id: server.id,
            system_server_version: server.serverVersion,
            secure_connection: server.secure_connection,
            is_egames: server.is_egames,
            hallId: this.props.inspectingHall.id,
            filter: {
                search: this.state.searchText,
                status: this.state.statusFilterValue,
                version: this.state.serverVersionFilterValue
            }
        });
    };

    closeCloneServer = () => {
        this.setState({
            cloningServer: null
        });
        this.props.updateCreationMode(null);
    };

    onClearFilters = () => {
        this.serverVersionFilter.current.selectItem([]);
        this.serverVersionFilter.current.setDisplayString("Choose System Server Version");

        this.setState({
            searchText: "",
            serverVersionFilterValue: "",
            statusFilterValue: "true",
        });
    };

    applyFilters = (value, field) => {
        let updatedState = {...this.state};
        updatedState[field] = value
        this.setState({
            ...updatedState,
        }, this.getServers)
    }

    openConfirmUploadRemotely = () => {
        let state = {...this.state}
        const supportsGameLogos = supportsRemoteGameLogoUpdate(
            state.confirmUploadRemotely.serverVersion
        );
        const gameRTPProfiles = supportsRemoteRTPProfileUpdate(
            state.confirmUploadRemotely.serverVersion
        )
            ? prepareRemoteRTPProfiles(
                  state.confirmUploadRemotely.gameRTPProfiles
              )
            : [];
        this.setState({
            confirmUploadRemotely: {
                open: true,
                serverId: state.confirmUploadRemotely.serverId,
                serverVersion: state.confirmUploadRemotely.serverVersion,
                gameRTPProfiles: state.confirmUploadRemotely.gameRTPProfiles
            },
            uploadRemotelyDialog: false,
            includeServerConfig: true,
            includeGameLogos: supportsGameLogos,
            gameRTPProfiles
        })
    }

    closeUploadRemotelyDialog = () => {
        this.setState({
            confirmUploadRemotely: {
                ...this.state.confirmUploadRemotely,
                open: false,
            },
            uploadRemotelyDialog: false,
            selectedUpdateTime: null,
            selectedUpdateTimeValid: false
        })
    }

    uploadRemotely = () => {
        const includes = getRemoteUpdateIncludes(
            this.state.confirmUploadRemotely.serverVersion,
            this.state.includeServerConfig,
            this.state.includeGameLogos,
            this.state.gameRTPProfiles
        );
        this.props.uploadConfigurationRemotely({
            serverId: Number(this.state.confirmUploadRemotely.serverId),
            update_time: this.state.selectedUpdateTime,
            ...includes
        })
        this.closeUploadRemotelyDialog()
    }

    render() {
        const supportsGameLogoUpdate = supportsRemoteGameLogoUpdate(
            this.state.confirmUploadRemotely.serverVersion
        );
        const hasRemoteRTPProfiles =
            supportsRemoteRTPProfileUpdate(
                this.state.confirmUploadRemotely.serverVersion
            ) && this.state.gameRTPProfiles.length > 0;
        const supportsRemoteUpdateOptions =
            supportsGameLogoUpdate || hasRemoteRTPProfiles;
        const serverStatus = [
            {
                value: "",
                label: "All"
            },
            {
                value: "true",
                label: "Active"
            },
            {
                value: "false",
                label: "Inactive"
            }
        ];
        const hasLicensesAccess = checkAuthorization({
            service: AuthorizationServiceTypes.LICENSES
        });
        return (
            <div className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="heading-container">
                                <ReturnTo
                                    to={["/halls/", ""]}
                                    label={[
                                        "Halls",
                                        this.props.inspectingHall
                                            ? this.props.inspectingHall.name
                                            : ""
                                    ]}
                                />
                            </div>
                            {checkPermission("create_servers") && (
                                <div className="new-server">
                                    <a
                                        className="red-btn"
                                        onClick={this.addServerClick}
                                    >
                                        <span>New Server</span>
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="presets-filters">
                                <div id="PresetsPageFiltersBox">
                                    <div className="row">
                                        <div className="adjustable-filters">
                                            <div className="preset-filter">
                                                <label className="label">
                                                    Search
                                                </label>
                                                <input
                                                    className="input"
                                                    onChange={
                                                        event =>
                                                            this.applyFilters(event.target.value, 'searchText')
                                                    }
                                                    value={
                                                        this.state
                                                            .searchText
                                                    }
                                                    placeholder="Server name"
                                                />
                                            </div>

                                            <div className="preset-filter">
                                                <label className="label">
                                                    Versions
                                                </label>
                                                <Components.SelectMenu
                                                    key={`${this.state.serverVersionFilterValue}`}
                                                    ref={
                                                        this
                                                            .serverVersionFilter
                                                    }
                                                    noValueLabel="Choose System Server Version"
                                                    multipleSelection
                                                    items={
                                                        this.props.coreVersions
                                                            ? this.props.coreVersions.map(
                                                                ver => {
                                                                    return {
                                                                        value: ver.version,
                                                                        label: ver.version
                                                                    };
                                                                }
                                                            )
                                                            : []
                                                    }
                                                    onChange={
                                                        event =>
                                                            this.applyFilters(event, 'serverVersionFilterValue')
                                                    }
                                                    value={this.state.serverVersionFilterValue}
                                                />
                                            </div>
                                            <div className="adjustable-filters">
                                                <div className="preset-filter">
                                                    <label className="label">
                                                        Status
                                                    </label>
                                                    <Components.CheckboxGroup
                                                        key={this.state.statusFilterValue}
                                                        items={serverStatus}
                                                        selected={this.state.statusFilterValue}
                                                        onChange={event =>
                                                            this.applyFilters(event, 'statusFilterValue')}
                                                    />
                                                </div>
                                            </div>

                                            <div>
                                                <button
                                                    className="clear-filters-btn"
                                                    onClick={
                                                        this.onClearFilters
                                                    }
                                                >
                                                    Clear All Filters
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="list-cards">
                        <div className="row">
                            <div className="cards-container">
                                <div className="info-card">
                                    <HallBasicInfoCard
                                        onOpenEditHall={this.onOpenEditHall}
                                        onOpenDelHall={this.delHallClick}
                                        inspectingHallServers={
                                            this.props
                                                .inspectingHallServersLoading
                                                ? []
                                                : this.props
                                                    .inspectingHallServers

                                        }
                                        inspectingHallServersLoading={
                                            this.props
                                                .inspectingHallServersLoading
                                        }
                                    />
                                </div>

                                {this.props.inspectingHallServers.map(
                                    (server, index) => (
                                        <div key={index} className="info-card">
                                            <ServerCard
                                                server={server}
                                                hall={
                                                    this.props.match.params[
                                                        "hallId"
                                                        ]
                                                }
                                                subsidiary={this.props.inspectingHall ? this.props.inspectingHall.subsidiary.id : null}
                                                subsidiaryDescription={this.props.inspectingHall ? this.props.inspectingHall.subsidiary.description : null}
                                                subtitle={server.name}
                                                hasLicensesAccess={
                                                    hasLicensesAccess
                                                }
                                                system_server_version={
                                                    server.system_server_version
                                                        ? server.system_server_version
                                                        : null
                                                }
                                                type={
                                                    server.type
                                                        ? server.type
                                                        : null
                                                }
                                                secure_connection={server.secure_connection ? server.secure_connection : false}
                                                active={
                                                    server.active
                                                        ? server.active
                                                        : null
                                                }
                                                toggleActiveServerAction={
                                                    this.props.activateServer
                                                }
                                                editAction={this.onEdit}
                                                cloneAction={this.onClone}
                                                toggleServerDebugMode={this.props
                                                    .toggleServerDebugMode}
                                                toggleServerPerpetualLicense={this.props.toggleServerPerpetualLicense}
                                                productionServer={this.props.productionServer}
                                                uploadConfigurationRemotely={(serverId, auto_session_enabled) => {
                                                    const gameRTPProfiles =
                                                        prepareRemoteRTPProfiles(
                                                            server.config &&
                                                                server.config.game_rtp_profiles
                                                        );
                                                    auto_session_enabled === "auto" ?
                                                        this.setState({
                                                            uploadRemotelyDialog: true, confirmUploadRemotely: {
                                                                open: false,
                                                                serverId: serverId,
                                                                serverVersion: server.system_server_version,
                                                                gameRTPProfiles
                                                            },
                                                            gameRTPProfiles
                                                        })
                                                        :
                                                        this.setState({
                                                            confirmUploadRemotely: {
                                                                open: true,
                                                                serverId: serverId,
                                                                serverVersion: server.system_server_version,
                                                                gameRTPProfiles
                                                            },
                                                            includeServerConfig: true,
                                                            includeGameLogos: supportsRemoteGameLogoUpdate(
                                                                server.system_server_version
                                                            ),
                                                            gameRTPProfiles: supportsRemoteRTPProfileUpdate(
                                                                server.system_server_version
                                                            )
                                                                ? gameRTPProfiles
                                                                : []
                                                        })
                                                }}
                                            />
                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {this.props.creationMode == CreationModes.ADD_SERVER && (
                    <Drawer
                        ref={this.drawerRef}
                        title="New Server"
                        onClose={this.onDialogClose}
                    >
                        <ServerCreate
                            onConfirm={this.onDialogConfirm}
                            onClose={this.onDialogClose}
                            coreVersions={this.props.coreVersions}
                            secure_connection={this.props.secure_connection}
                            hall={this.props.inspectingHall}
                            loadingHall={this.props.inspectingHallLoading}
                            loading={this.props.submittingServerLoading}
                        />
                    </Drawer>
                )}
                {this.props.creationMode == CreationModes.CLONE_SERVER && (
                    <Drawer
                        ref={this.drawerRef}
                        title="Clone Server"
                        onClose={this.closeCloneServer}
                    >
                        <ServerClone
                            name={this.state.cloningServer.name}
                            id={this.state.cloningServer.id}
                            coreVersion={this.state.cloningServer.system_server_version}
                            secureConnection={this.state.cloningServer.secure_connection}
                            isEGames={this.state.cloningServer.is_egames}
                            onConfirm={this.onCloneConfirm}
                            onClose={this.closeCloneServer}
                            coreVersions={this.props.coreVersions}
                            hall={this.props.inspectingHall}
                            loadingHall={this.props.inspectingHallLoading}
                            loading={this.props.submittingServerLoading}
                        />
                    </Drawer>
                )}
                {this.props.creationMode == CreationModes.EDIT_HALL && (
                    <Drawer
                        ref={this.drawerRef}
                        title="Edit Hall"
                        onClose={this.closeCreateHall}
                    >
                        <CreateHall/>
                    </Drawer>
                )}

                {this.props.creationMode == CreationModes.EDIT_SERVER && (
                    <Drawer
                        ref={this.drawerRefEdit}
                        title="Edit Server"
                        onClose={this.closeEditServer}
                    >
                        <ServerEdit
                            name={this.state.editingServer.name}
                            id={this.state.editingServer.id}
                            onClose={this.closeEditServer}
                            onConfirm={this.onEditConfirm}
                            loading={this.props.submittingServerLoading}
                        />
                    </Drawer>
                )}

                <Dialog
                    open={this.state.showDelHall}
                    onConfirm={this.onDeleteHall}
                    onClose={this.closeDelHall}
                >
                    Are you sure you want to delete this Hall?
                </Dialog>

                <Dialog
                    open={this.state.confirmUploadRemotely.open}
                    onConfirm={this.uploadRemotely}
                    onClose={this.closeUploadRemotelyDialog}
                    addedClassName="spec-detail-dialog"
                >
                    <p>
                        <b>
                            {supportsRemoteUpdateOptions
                                ? "Remote Update"
                                : "ATTENTION"}
                        </b>
                    </p>
                    <span>
                        {supportsRemoteUpdateOptions ? (
                            supportsGameLogoUpdate ? "Choose what to update" : null
                        ) : (
                            <React.Fragment>
                                Are you sure you want to update the <b>latest</b>{" "}
                                configuration of this server remotely?
                            </React.Fragment>
                        )}
                    </span>
                    {supportsRemoteUpdateOptions && (
                        <RemoteUpdateOptions
                            includeServerConfig={this.state.includeServerConfig}
                            includeGameLogos={this.state.includeGameLogos}
                            showServerConfig={supportsGameLogoUpdate}
                            showGameLogos={supportsGameLogoUpdate}
                            gameRTPProfiles={this.state.gameRTPProfiles}
                            onServerConfigChange={includeServerConfig =>
                                this.setState({includeServerConfig})
                            }
                            onGameLogosChange={includeGameLogos =>
                                this.setState({includeGameLogos})
                            }
                            onRTPProfileForceChange={(index, force) => {
                                const gameRTPProfiles = this.state.gameRTPProfiles.map(
                                    (profile, profileIndex) =>
                                        profileIndex === index
                                            ? {...profile, force}
                                            : profile
                                );
                                this.setState({gameRTPProfiles});
                            }}
                            onAllRTPProfilesForceChange={force =>
                                this.setState({
                                    gameRTPProfiles: this.state.gameRTPProfiles.map(
                                        profile => ({...profile, force})
                                    )
                                })
                            }
                        />
                    )}
                </Dialog>

                <Dialog
                    open={this.state.uploadRemotelyDialog}
                    onConfirm={this.openConfirmUploadRemotely}
                    onClose={this.closeUploadRemotelyDialog}
                    confirmLabel="Continue"
                    validSubmit={this.state.selectedUpdateTimeValid}
                    addedClassName="download-session-time-dialog"
                >
                    <h3>Update Remotely Configuration with Auto Session</h3>
                    <div className="warning">
                        <b>Info:</b> Filling the update time does not update the
                        config version, even if downloaded with different Update
                        Times, the server will only accept this configuration
                        once.
                    </div>
                    <Form
                        fields={sessionTimeFormFields}
                        initialValues={{}}
                        onChange={formValues => {
                            this.setState({
                                selectedUpdateTime: formValues.values.update_time,
                                selectedUpdateTimeValid: formValues.isValid
                            });
                        }}
                    />
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    inspectingHall: hallsStoreSelectors.inspectingHall(state),
    inspectingHallLoading: hallsStoreSelectors.inspectingHallLoading(state),
    inspectingHallServers: hallsStoreSelectors.select("inspectingHallServers")(
        state
    ),
    inspectingHallServersLoading:
        hallsStoreSelectors.inspectingHallServersLoading(state),
    coreVersions: hallsStoreSelectors.coreVersions(state),
    creationMode: hallsStoreSelectors.creationMode(state),
    serversInfo: hallsStoreSelectors.serversInfo(state),
    serversInfoLoading: hallsStoreSelectors.serversInfoLoading(state),
    submittingServerLoading: hallsStoreSelectors.submittingServerLoading(state),
    productionServer: hallsStoreSelectors.productionServer(state)
});

const mapDispatchToProps = {
    getHall: HallsActionCreators.getHall,
    getServers: HallsActionCreators.getServers,
    getCoreVersions: HallsActionCreators.getCoreVersions,
    createServer: HallsActionCreators.createServer,
    cloneServer: HallsActionCreators.cloneServer,
    updateCreationMode: HallsActionCreators.updateCreationMode,
    clearCreateHall: HallsActionCreators.clearCreateHall,
    deleteHall: HallsActionCreators.deleteHall,
    activateServer: HallsActionCreators.activateServer,
    updateCreatingHall: HallsActionCreators.updateCreatingHall,
    updateServer: HallsActionCreators.updateServer,
    toggleServerDebugMode: HallsActionCreators.toggleServerDebugMode,
    toggleServerPerpetualLicense: HallsActionCreators.toggleServerPerpetualLicense,
    getProductionServer: HallsActionCreators.getProductionServer,
    uploadConfigurationRemotely: HallsActionCreators.uploadConfigurationRemotely
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(HallPage));
